var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50H26.875V52.5C26.875 53.8812 27.9937 55 29.375 55H35.625C37.0062 55 38.125 53.8812 38.125 52.5V50H40C42.7609 50 45 47.7609 45 45V10C45 7.23906 42.7609 5 40 5V2.5C40 1.11875 38.8812 0 37.5 0H27.5C26.1187 0 25 1.11875 25 2.5V5C22.2391 5 20 7.23906 20 10V45C20 47.7609 22.2391 50 25 50ZM72.5 70H72.2984C77.0687 64.6859 80 57.6875 80 50C80 33.4562 66.5437 20 50 20V30C61.0281 30 70 38.9719 70 50C70 61.0281 61.0281 70 50 70H7.5C3.35781 70 0 73.3578 0 77.5C0 78.8812 1.11875 80 2.5 80H77.5C78.8812 80 80 78.8812 80 77.5C80 73.3578 76.6422 70 72.5 70ZM16.25 65H48.75C49.4406 65 50 64.4406 50 63.75V61.25C50 60.5594 49.4406 60 48.75 60H16.25C15.5594 60 15 60.5594 15 61.25V63.75C15 64.4406 15.5594 65 16.25 65Z",
    fill: "#F26739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.a99b74f8370b8d2c466616e0ad949bb2.svg";
export { ForwardRef as ReactComponent };